<template>
  <v-container fluid>
    <v-card v-if="dataDentroPrazoInscricao">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Inscrição - Organização ou Entidade Cultural</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-stepper v-model="etapaFormulario">
          <v-stepper-header>
            <v-stepper-step :complete="etapaFormulario > 1" step="1">
              Organização ou Entidade Cultural
            </v-stepper-step>

            <v-divider />

            <v-stepper-step :complete="etapaFormulario > 2" step="2">
              Responsável pela Organização ou Entidade Cultural
            </v-stepper-step>

            <v-divider />

            <v-stepper-step :complete="etapaFormulario > 3" step="3"> Segmento </v-stepper-step>

            <v-divider />

            <v-stepper-step :complete="etapaFormulario > 4" step="4"> Critérios </v-stepper-step>

            <v-divider />

            <v-stepper-step :complete="etapaFormulario > 5" step="5"> Anexos </v-stepper-step>



            <!--<v-stepper-step-->
            <!--:complete="etapaFormulario > 5"-->
            <!--step="5">-->
            <!--Anexo-->
            <!--</v-stepper-step>-->
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="form_dados_entidade" v-model="valid_dados_entidade" lazy-validation>
                <v-card flat>
                  <v-container fluid grid-list-xl>
                    <v-layout wrap align-center>
                      <v-flex xs12 sm5>
                        <v-text-field v-model="organizacao.nu_cnpj" label="*CNPJ" append-icon="people"
                          placeholder="99.999.999/9999-99" :error-messages="nomeOrganizacaoError"
                          mask="##.###.###/####-##" :rules="[rules.required, rules.cnpjMin]" required />
                      </v-flex>
                      <v-flex xs12 sm5>
                        <v-text-field v-model="organizacao.no_organizacao" label="*Nome da Organização/Entidade"
                          append-icon="perm_identity" :disabled="true" :error-messages="nomeOrganizacaoError"
                          :rules="[rules.cnpjInvalido]" required />
                      </v-flex>

                      <v-flex xs12 sm2>
                        <v-text-field v-model="organizacao.nu_telefone" label="*Telefone" append-icon="phone"
                          placeholder="(99) 99999-9999" mask="(##) #####-####" :rules="[rules.required, rules.phoneMin]"
                          required />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm4>
                        <v-text-field v-model="organizacao.ds_email" data-vv-name="email" label="*E-mail"
                          append-icon="mail" placeholder="email@exemplo.com" :rules="[rules.required, rules.email]"
                          counter maxlength="100" required />
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-text-field v-model="organizacao.ds_email_confirmacao" label="*Confirmar e-mail"
                          append-icon="mail" placeholder="email@exemplo.com" :rules="[
                            rules.required,
                            rules.email,
                            rules.emailMatch(
                              organizacao.ds_email,
                              organizacao.ds_email_confirmacao
                            ),
                          ]" counter maxlength="100" required />
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-text-field v-model="organizacao.ds_sitio_eletronico"
                          label="Sítio eletrônico da Organização/Entidade" append-icon="public" counter maxlength="250"
                          :rules="[rules.url]" />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.endereco.nu_cep" label="*CEP" append-icon="my_location"
                          placeholder="99999-999" mask="#####-###" :rules="[rules.required, rules.cepMin]" required />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="organizacao.endereco.ds_logradouro" label="*Logradouro"
                          append-icon="place" :rules="[rules.required]" counter maxlength="250" required />
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.endereco.ds_complemento" counter maxlength="250"
                          label="Complemento" />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm3>
                        <v-select v-model="organizacao.endereco.co_ibge" :items="listaUF"
                          label="*Unidade da federação da sede" append-icon="place" item-value="co_ibge"
                          item-text="no_uf" :rules="[rules.required]" required />
                      </v-flex>
                      <v-flex xs12 sm5>
                        <v-select v-model="organizacao.endereco.co_municipio" :items="listaMunicipios" label="*Cidade"
                          append-icon="place" item-value="co_municipio" item-text="no_municipio"
                          :rules="[rules.required]" :disabled="
                            organizacao.endereco.co_ibge < 1 || organizacao.endereco.co_ibge == null
                          " />
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.endereco.no_bairro" counter maxlength="250"
                          label="Bairro" append-icon="place"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-form>
              <v-btn to="/inicio" flat> Cancelar </v-btn>
              <v-btn color="primary" @click="validarIrProximaEtapa('form_dados_entidade')">
                Próximo
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="form_representante" v-model="valid_representante" lazy-validation>
                <v-card flat>
                  <v-container fluid grid-list-xl>
                    <v-layout wrap align-center>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.representante.nu_cpf" label="*CPF do representante"
                          append-icon="person" placeholder="999.999.999.99" mask="###.###.###.##"
                          :rules="[rules.required, rules.cpfMin]" required />
                      </v-flex>
                      <v-flex xs12 sm5>
                        <v-text-field v-model="organizacao.representante.no_nome" label="*Nome do representante"
                          :disabled="true" :error-messages="nomeRepresentante" append-icon="perm_identity"
                          :rules="[rules.cpfInvalido]" required />
                      </v-flex>
                      <v-flex xs12 sm2>
                        <v-text-field v-model="organizacao.representante.nu_rg" label="*RG do representante"
                          append-icon="person" mask="###########" counter maxlength="11" :rules="[rules.required]"
                          required />
                      </v-flex>
                      <v-flex xs12 sm2>
                        <v-text-field v-model="organizacao.representante.nu_telefone" label="*Celular do representante"
                          append-icon="phone" placeholder="(99) 99999-9999" mask="(##) #####-####"
                          :rules="[rules.required, rules.phoneMin]" required />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center> </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="organizacao.representante.ds_email" label="*E-mail do representante"
                          append-icon="mail" placeholder="email@exemplo.com" :rules="[rules.required, rules.email]"
                          counter maxlength="250" required />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="organizacao.representante.ds_email_confirmation"
                          label="*Confirmar e-mail" append-icon="mail" placeholder="email@exemplo.com" :rules="[
                            rules.required,
                            rules.email,
                            rules.emailMatch(
                              organizacao.representante.ds_email,
                              organizacao.representante.ds_email_confirmation
                            ),
                          ]" counter maxlength="250" required />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.representante.endereco.nu_cep" label="*CEP"
                          append-icon="my_location" placeholder="99999-999" mask="#####-###"
                          :rules="[rules.required, rules.cepMin]" required />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="organizacao.representante.endereco.ds_logradouro" label="*Logradouro"
                          append-icon="place" :rules="[rules.required]" counter maxlength="250" required />
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.representante.endereco.ds_complemento" counter
                          maxlength="250" label="Complemento" />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm3>
                        <v-select v-model="organizacao.representante.endereco.co_ibge" :items="listaUF"
                          label="*Unidade da federação da sede" append-icon="place" item-value="co_ibge"
                          item-text="no_uf" :rules="[rules.required]" required />
                      </v-flex>

                      <v-flex xs12 sm3>
                        <v-select v-model="organizacao.representante.endereco.co_municipio" :items="listaMunicipiosRepresentante"
                          label="*Cidade" append-icon="place" item-value="co_municipio" item-text="no_municipio"
                          :rules="[rules.required]" :disabled="
                            organizacao.representante.endereco.co_ibge < 1 || organizacao.representante.endereco.co_ibge == null
                          " value="organizacao.representante.endereco.co_municipio"/>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-text-field v-model="organizacao.representante.endereco.no_bairro" counter maxlength="250"
                          label="Bairro" append-icon="place"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-form>
              <v-btn flat @click="voltarEtapaAnterior"> Anterior </v-btn>
              <v-btn :disabled="!valid_representante" color="primary"
                @click="validarIrProximaEtapa('form_representante')">
                Próximo
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="form_segmento" v-model="valid_segmento" lazy-validation>
                <v-card flat>
                  <v-container fluid grid-list-xl>
                    <v-layout wrap align-center>
                      <v-flex xs12 sm12>
                        <v-radio-group v-model="organizacao.co_segmento"
                          label="*Informe o segmento no qual pretende concorrer">
                          <v-radio v-for="(segmento, i) in listaSegmentos" :key="i" :label="segmento.ds_detalhamento"
                            :value="segmento.co_segmento" />
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-form>
              <v-btn flat @click="voltarEtapaAnterior"> Anterior </v-btn>
              <v-btn :disabled="!valid_segmento" color="primary" @click="validarIrProximaEtapa('form_segmento')">
                Próximo
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-form ref="form_criterio" v-model="valid_criterio" lazy-validation>
                <v-card flat>
                  <v-container fluid grid-list-xl>
                    <v-layout wrap align-center>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.abrangencia_nacional"
                          :items="listaCriterios.abrangencia_nacional" item-value="co_criterio"
                          item-text="ds_detalhamento" label="*Abrangência Nacional" :rules="[rules.required]" required
                          box hint="Atividades ou projetos culturais em, no mínimo, 5 estados de 2
                            macrorregiões brasileiras, a partir de 2016." persistent-hint />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.abrangencia_estadual"
                          :items="listaCriterios.abrangencia_estadual" item-value="co_criterio"
                          item-text="ds_detalhamento" label="*Abrangência Estadual" :rules="[rules.required]" required
                          box hint="Atividades ou projetos culturais em, no mínimo, 5 estados, a partir de 2016."
                          persistent-hint placeholder="Selecione" />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.tempo_funcionamento"
                          :items="listaCriterios.tempo_funcionamento" item-value="co_criterio"
                          item-text="ds_detalhamento" label="*Tempo de Funcionamento" :rules="[rules.required]" required
                          placeholder="Selecione" box hint="A partir da data de fundação." persistent-hint />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.nu_associados_filiados"
                          :items="listaCriterios.nu_associados_filiados" item-value="co_criterio"
                          item-text="ds_detalhamento" label="*Nº de Associados ou Filiados" :rules="[rules.required]"
                          required placeholder="Selecione" box hint="
                          Lista de associados ou filiados atestada pelo dirigente da organização ou
                          entidade cultural." persistent-hint />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.nu_atividades" :items="listaCriterios.nu_atividades"
                          item-value="co_criterio" item-text="ds_detalhamento"
                          label="*Nº Atividades/projetos realizados no campo cultural a partir de 2016"
                          :rules="[rules.required]" required placeholder="Selecione" box
                          hint="Comprovados por relatório de atividades e portfólio." persistent-hint />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.participacao_instancias"
                          :items="listaCriterios.participacao_instancias" item-value="co_criterio"
                          item-text="ds_detalhamento"
                          label="Participação em instâncias de formulação de política cultural" placeholder="Selecione"
                          box hint="
                          Na qualidade de conselheiro ou membro, comprovado por documento de
                          designação ou de posse." persistent-hint />
                      </v-flex>
                    </v-layout>

                    <v-layout wrap align-center>
                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.pesquisa_producao"
                          :items="listaCriterios.pesquisa_producao" item-value="co_criterio" item-text="ds_detalhamento"
                          label="
                          Projetos na área de pesquisa ou produção do conhecimento no campo da
                          cultura a partir de 2016" placeholder="Selecione" box
                          hint="Publicações, pesquisa de campo, artigos científicos." persistent-hint />
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-select v-model="organizacao.criterios.participacao_cnpc"
                          :items="listaCriterios.participacao_cnpc" item-value="co_criterio" item-text="ds_detalhamento"
                          label="
                          Participou como organizações e entidades culturais em mandatos anteriores do Conselho Nacional de Política Cultural" placeholder="Selecione" box
                          persistent-hint />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-form>
              <v-btn flat @click="voltarEtapaAnterior"> Anterior </v-btn>
              <v-btn :disabled="!valid_criterio" color="primary" @click="validarIrProximaEtapa('form_criterio')">
                Próximo
              </v-btn>

            </v-stepper-content>

            <v-stepper-content step="5">
              <v-form ref="form_anexo" v-model="valid_anexo" lazy-validation>
                <v-card flat>
                  <v-container fluid grid-list-xl>
                    <v-layout headline>
                      <v-flex>
                        <v-text class="heading">
                          A documentação deverá estar legível em formato PDF (preferncialmente) ou JPEG, cujo tamanho não exceda 100MB.
                        </v-text>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4 wrap>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Documento de identificação do representante legal responsável pela inscrição da organização
                            ou entidade cultural (conforme item 2.8 do edital)
                          </v-card-title>
                          <v-card-text>
                            <file v-model="documento_identificacao_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Documento de Cadastro de Pessoas Físicas (CPF) do representante legal responsável pela
                            inscrição da organização ou entidade cultural
                          </v-card-title>
                          <v-card-text>
                            <file v-model="cpf_representante_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Comprovante do Cadastro Nacional da Pessoa Jurídica (CNPJ) que comprove a existência da
                            entidade há pelo menos três anos
                          </v-card-title>
                          <v-card-text>
                            <file v-model="cnpj_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Documento de constituição da atual diretoria e da presidência, ou cargo equivalente, da
                            organização ou entidade cultural
                          </v-card-title>
                          <v-card-text>
                            <file v-model="documento_constituicao_executiva_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Documento de identificação (conforme item 2.8 do edital) do presidente, diretor executivo ou
                            cargo equivalente
                          </v-card-title>
                          <v-card-text>
                            <file v-model="documento_identificacao_executivo_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Documento de Cadastro de Pessoas Físicas (CPF) do presidente, diretor executivo ou cargo
                            equivalente
                          </v-card-title>
                          <v-card-text>
                            <file v-model="cpf_executivo_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Estatuto social ou contrato social atualizado, conforme o caso, devidamente registrado no
                            órgão competente, de modo a comprovar o caráter cultural da entidade e seu ano de criação
                          </v-card-title>
                          <v-card-text>
                            <file v-model="contrato_social_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Relatório anual das atividades culturais dos últimos 06 (seis) anos (2016, 2017, 2018, 2019,
                            2020, 2021), com ações realizadas, no mínimo, em três anos, contendo, minimamente: o resumo
                            de cada atividade, o local, o período de realização e o número de participantes
                          </v-card-title>
                          <v-card-text>
                            <file v-model="relatorio_anual_atividade_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Comprovação efetiva de que possui projetos ou atividades culturais realizados em ao menos 5
                            (cinco) estados de 2 (duas) macrorregiões brasileiras, a partir do exercício de 2016, por
                            meio de: portfólio, folders, publicações, listas de presença, revistas, jornais, conteúdos
                            de divulgação, links de vídeos, registros fotográficos ou outros materiais que permitam,
                            minimamente, a identificação de data e local de realização das atividades e a aferição da
                            veracidade das informações apresentadas. Anexar em único arquivo
                          </v-card-title>
                          <v-card-text>
                            <file v-model="comprovativo_atividade_cultural_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            *Lista de associados ou filiados atestada pelo dirigente da organização ou entidade cultural
                          </v-card-title>
                          <v-card-text>
                            <file v-model="lista_associados_atestada_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            Documentação que comprove a atuação da organização ou entidade cultural em instâncias
                            colegiadas do setor cultural, tais como conselhos, comissões ou câmaras, se houver, por meio
                            de termo de posse ou portaria de designação de representante
                          </v-card-title>
                          <v-card-text>
                            <file v-model="comprovativo_atuacao_setor_cultural_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex sm3>
                        <v-card max-width="500" min-height="150" class="mx-auto">
                          <v-card-title class="subheading mb-1 justify-center">
                            Documentação que comprove a realização de projetos na área de pesquisa ou produção do
                            conhecimento no campo da cultura a partir de 2016, tais como: publicações, pesquisa de campo
                            e artigos científicos
                          </v-card-title>
                          <v-card-text>
                            <file v-model="comprovativo_realizacao_projeto_cultural_organizacao" max-file-size="100MB" :accepted-file-types="acceptedFileTypes" />
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-form>
              <v-btn flat @click="voltarEtapaAnterior">
                Anterior
              </v-btn>
              <v-btn color="primary" @click="salvar">
                Enviar
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {groupBy} from "lodash";
import Validate from "../../shared/util/validate";
import codigosPerfil from "../../conta/utils/codigosPerfil";
import { eventHub } from "@/event";
import File from '@/core/components/upload/File';

export default {
  components: { File },
  name: 'Organizacao',
  data: () => ({
    dataDentroPrazoInscricao: false,
    nomeOrganizacaoError: '',
    nomeRepresentante: '',
    mascaraTelefone: '(##) #####-####',
    valid_dados_entidade: false,
    valid_segmento: false,
    valid_criterio: false,
    valid_representante: false,
    valid_anexo: false,
    etapaFormulario: 1,
    listaUF: [],
    listaSegmentos: [],
    listaMunicipios: [],
    listaMunicipiosRepresentante: [],
    listaCriterios: [],
    organizacao: {
      st_inscricao: 'e',
      co_segmento: '',
      no_organizacao: '',
      ds_email: '',
      ds_email_confirmacao: '',
      nu_telefone: '',
      nu_cnpj: '',
      endereco: {
        co_ibge: '',
        ds_complemento: '',
        nu_cep: '',
        ds_logradouro: '',
        co_municipio: '',
        no_bairro:''
      },
      representante: {
        ds_email: '',
        no_nome: '',
        nu_rg: '',
        nu_cpf: '',
        nu_telefone: '',
        ds_email_confirmation: '',
        endereco: {
          co_ibge: '',
          ds_complemento: '',
          nu_cep: '',
          ds_logradouro: '',
          co_municipio: '',
          no_bairro: ''
        },
      },
      ds_sitio_eletronico: '',
      criterios: {
        abrangencia_estadual: '',
        abrangencia_nacional: '',
        nu_associados_filiados: '',
        nu_atividades: '',
        participacao_instancias: '',
        pesquisa_producao: '',
        tempo_funcionamento: '',
        participacao_cnpc: '',
      },
      anexos: []
    },
    documento_identificacao_organizacao: {},
    cpf_representante_organizacao: {},
    cnpj_organizacao: {},
    documento_constituicao_executiva_organizacao: {},
    documento_identificacao_executivo_organizacao: {},
    cpf_executivo_organizacao: {},
    contrato_social_organizacao: {},
    relatorio_anual_atividade_organizacao: {},
    comprovativo_atividade_cultural_organizacao: {},
    lista_associados_atestada_organizacao: {},
    comprovativo_atuacao_setor_cultural_organizacao: {},
    comprovativo_realizacao_projeto_cultural_organizacao: {},
    acceptedFileTypes:  [
      'image/jpeg',
      'application/pdf',
    ],
    // declaracao_representante_legal: {},
    // documento_identificacao_responsavel: {},
    headers: [
      {
        text: 'Tipo',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Arquivo',
        align: 'center',
        sortable: false,
      },
      {
        sortable: false,
      },
    ],
    rules: {
      required: (v) => !!v || 'Campo não preenchido',
      cnpjInvalido: (v) => !!v || 'CNPJ não encontrado',
      cpfInvalido: (v) => !!v || 'CPF não encontrado',
      phoneMin: (v) => (v && v.length >= 9) || 'Mínimo de 9 caracteres',
      cnpjMin: (v) => (v && v.length === 14) || 'Mínimo de 14 caracteres',
      cpfMin: (v) => (v && v.length === 11) || 'Mínimo de 11 caracteres',
      cepMin: (v) => (v && v.length === 8) || 'Mínimo de 8 caracteres',
      email: (v) => {
        // eslint-disable-next-line
        const pattern =
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || 'E-mail invalido';
      },
      url: (v) => {
        // eslint-disable-next-line
        const pattern =
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
        if (v) return pattern.test(v) || 'Sítio invalido';
        return true;
      },
      emailMatch: (email, emailConfirmation) =>
        email === emailConfirmation || 'Os emails não correspondem',
    },
  }),
  watch: {
    estadosGetter() {
      this.listaUF = this.estadosGetter;
    },
    municipiosGetter() {
      if(this.etapaFormulario==1){
        this.listaMunicipios = this.municipiosGetter;
      }else{
        this.listaMunicipiosRepresentante = this.municipiosGetter;
      }
    },
    segmentosGetter() {
      this.listaSegmentos = this.segmentosGetter;
    },
    'organizacao.endereco.co_ibge': function (coIBGE) {
      this.obterMunicipios(coIBGE);
    },
    'organizacao.representante.endereco.co_ibge': function (coIBGE) {
      this.obterMunicipios(coIBGE);
    },
    'organizacao.nu_cnpj': function (value) {
      const self = this;
      self.organizacao.no_organizacao = '';
      this.nomeOrganizacaoError = 'CNPJ inválido';
      if (value.length === 14 && Validate.isCnpjValido(value)) {
        this.consultarCNPJ(value).then((response) => {
          const { data } = response.data;
          self.organizacao.no_organizacao = data.nmRazaoSocial;
        });
        this.nomeOrganizacaoError = '';
      }
    },
    'organizacao.representante.nu_cpf': function (value) {
      const self = this;
      self.organizacao.representante.no_nome = '';
      this.nomeRepresentante = 'CPF inválido';
      if (value.length === 11 && Validate.isCpfValido(value)) {
        this.consultarCPF(value).then((response) => {
          const { data } = response.data;
          self.organizacao.representante.no_nome = data.nmPessoaFisica;
        });
        this.nomeRepresentante = '';
      }
    },
    criteriosGetter() {
      this.listaCriterios = groupBy(this.criteriosGetter, (criterio) => criterio.tp_criterio);

      const participacaoInstancias = [
        {
          co_criterio: '',
          ds_detalhamento: 'Selecione',
          tp_criterio: 'participacao_instancias',
        },
      ];
      this.listaCriterios.participacao_instancias.forEach((criterio) => {
        participacaoInstancias.push(criterio);
      });
      this.listaCriterios.participacao_instancias = participacaoInstancias;

      const pesquisaProducao = [
        {
          co_criterio: '',
          ds_detalhamento: 'Selecione',
          tp_criterio: 'pesquisa_producao',
        },
      ];
      this.listaCriterios.pesquisa_producao.forEach((criterio) => {
        pesquisaProducao.push(criterio);
      });
      this.listaCriterios.pesquisa_producao = pesquisaProducao;

      const participacaoCNPC = [
        {
          co_criterio: '',
          ds_detalhamento: 'Selecione',
          tp_criterio: 'participacao_cnpc',
        },
      ];
      this.listaCriterios.participacao_cnpc.forEach((criterio) => {
        participacaoCNPC.push(criterio);
      });
      this.listaCriterios.participacao_cnpc = participacaoCNPC;
    },
  },
  mounted() {
    const self = this;

    this.checkSubscription();

    this.obterFases().then((response) => {
      const { data } = response.data;
      const faseSlug = 'abertura_inscricoes_organizacao';
      const faseOrganizacao = data.find((fase) => fase.tp_fase === faseSlug);

      if (
        (!faseOrganizacao || Object.keys(faseOrganizacao).length === 0) &&
        self.perfil.no_perfil !== 'administrador'
      ) {
        self.mensagemErro('O prazo de inscrições expirou!');
        self.$router.push('/');
      }
      self.dataDentroPrazoInscricao = true;
    });

    if (Object.keys(this.organizacaoGetter).length > 0) {
      this.organizacao = this.organizacaoGetter;
      this.obterMunicipios(this.organizacao.endereco.co_municipio);
    }
    this.obterEstados();
    this.obterSegmentos();
    this.obterCriterios();
  },
  computed: {
    ...mapGetters({
      estadosGetter: 'localidade/estados',
      municipiosGetter: 'localidade/municipios',
      segmentosGetter: 'organizacao/segmentos',
      criteriosGetter: 'organizacao/criterios',
      organizacaoGetter: 'organizacao/organizacao',
      ativarInscricaoOrganizacao: 'fase/ativarInscricaoOrganizacao',
      perfil: 'conta/perfil',
    }),
  },
  methods: {
    ...mapActions({
      validarDataDentroPrazoFasePorSlug: 'fase/validarDataDentroPrazoFasePorSlug',
      mensagemErro: 'app/setMensagemErro',
      obterEstados: 'localidade/obterEstados',
      obterMunicipios: 'localidade/obterMunicipios',
      obterCriterios: 'organizacao/obterCriterios',
      obterSegmentos: 'organizacao/obterSegmentos',
      confirmarOrganizacao: 'organizacao/confirmarOrganizacao',
      consultarCNPJ: 'pessoa/consultarCNPJ',
      consultarCPF: 'pessoa/consultarCPF',
      obterFases: 'fase/obterFases',
    }),
    validarIrProximaEtapa(formRef) {
      if (this.$refs[formRef].validate()) {
        this.etapaFormulario = this.etapaFormulario + 1;
      }
    },
    voltarEtapaAnterior() {
      this.etapaFormulario = this.etapaFormulario - 1;
    },
    reset() {
      this.$refs.form.reset();
    },
    salvar() {
      let erro = false;
      this.organizacao.anexos = [];
      const anexos = [
        'documento_identificacao_organizacao',
        'cpf_representante_organizacao',
        'cnpj_organizacao',
        'documento_constituicao_executiva_organizacao',
        'documento_identificacao_executivo_organizacao',
        'cpf_executivo_organizacao',
        'contrato_social_organizacao',
        'relatorio_anual_atividade_organizacao',
        'comprovativo_atividade_cultural_organizacao',
        'lista_associados_atestada_organizacao',
        'comprovativo_atuacao_setor_cultural_organizacao',
        'comprovativo_realizacao_projeto_cultural_organizacao',
      ];
      try {
        anexos.forEach((nomeAnexo) => {
          if (
            (nomeAnexo === 'comprovativo_atuacao_setor_cultural_organizacao' 
            || nomeAnexo === 'comprovativo_realizacao_projeto_cultural_organizacao')
            && Object.values(this[nomeAnexo]).length === 0) 
          {
            return;
          }

          this.organizacao.anexos.push({
            tp_arquivo: nomeAnexo,
            no_extensao: this[nomeAnexo].fileExtension,
            no_mime_type: this[nomeAnexo].fileType,
            no_arquivo: this[nomeAnexo].filename,
            arquivoCodificado: this[nomeAnexo].getFileEncodeBase64String()
          })
        });
      } catch (e) {
        erro = true;
        eventHub.$emit('eventoErro', 'Informe os anexos obrigatórios!');
      }
      if (this.$refs.form_criterio.validate() && !erro) {
        this.confirmarOrganizacao(this.organizacao).then(() => {
          this.$router.push('/organizacao/revisao-organizacao');
        });
      }
    },
    checkSubscription() {
      if(this.perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR){
        return;
      }
      
      if (!this.ativarInscricaoOrganizacao) {
        eventHub.$emit('eventoErro', 'Período de inscrição encerrado!');
        this.$router.push('/');
      }
    },
  },
};
</script>
